import { ModalOpen } from './modalToggle';

const modalCenter = {
  button: document.querySelectorAll('.js-modal-center-button'),
  content: document.querySelectorAll('.js-modal-center-content'),
  closebg: document.querySelector<HTMLElement>(
    '.js-modal-bg-black'
  ) as HTMLElement,
};

export const AddModalCenter = () => {
  if (modalCenter.button) {
    modalCenter.button.forEach((button) => {
      document.addEventListener('click', (event) => {
        if ((event as any).target.closest('.js-modal-center-button')) {
          const modalContent: HTMLElement = button.querySelector(
            '.js-modal-center-content'
          ) as HTMLElement;
          ModalOpen(modalContent as HTMLElement);
        }
      });
    });
  }
};
AddModalCenter();
